import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import styles from "./FloorMapping.module.css"; // Importing updated styles
import cssClasses from "../Allotments/Allotments.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { getTokenServerTime } from "../../Services/Tokens";

const FloorMappingNew = () => {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { paymentId, tokenNo, wingName, wingId } = location.state || {};

  const [unitsData, setUnitsData] = useState([]);
  const [floorData, setFloorData] = useState([]);
  const [priceRanges, setPriceRanges] = useState({
    floor1to3: { min: 0, max: 0, avg: 0 },
    floor4to7: { min: 0, max: 0, avg: 0 },
    floor8to16: { min: 0, max: 0, avg: 0 },
    floorAbove16: { min: 0, max: 0, avg: 0 },
  });
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const fetchUnits = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getAllUnitsFromLaunchesForCustomerFastBooking`,
        { wingId, wingName }
      );
      if (res.data?.data) {
        setUnitsData(res.data.data); // Set raw units data
      }
    } catch (error) {
      console.error("Error fetching units:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const updateScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 600); // Check for small screens
    };
    window.addEventListener("resize", updateScreenSize);
    updateScreenSize(); // Initial check
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  useEffect(() => {
    fetchUnits(); // Call fetchUnits once when the component mounts
  }, []);


  useEffect(() => {
    if (unitsData.length > 0) {
      const floorMap = unitsData.reduce((acc, unit) => {
        const floorNo = unit.unitId?.floorNo;
        if (!floorNo) return acc;
        if (!acc[floorNo]) acc[floorNo] = { units: [], availableCount: 0, soldCount: 0, totalCost: 0 };

        const isAvailable = unit.unitId?.inventoryStatusId === "e2c12f90-0240-49d5-b31e-177a8c836ecc";
        acc[floorNo].units.push(unit);
        if (isAvailable) acc[floorNo].availableCount += 1;
        else acc[floorNo].soldCount += 1;
        acc[floorNo].totalCost += unit.unitId.totalCost || 0;

        return acc;
      }, {});

      // Sort floors in descending order (e.g., FLOOR 25 should come before FLOOR 15)
      const sortedFloors = Object.keys(floorMap)
        .map(floorNo => ({
          floorNo,
          ...floorMap[floorNo],
        }))
        .sort((a, b) => parseInt(b.floorNo.replace("FLOOR ", ""), 10) - parseInt(a.floorNo.replace("FLOOR ", ""), 10));

      setFloorData(sortedFloors);
      calculatePriceRanges(sortedFloors);
    }
  }, [unitsData]);

  const calculatePriceRanges = (floors) => {
    let priceRanges = {
      floor1to3: { min: Infinity, max: -Infinity, avg: 0, unitCount: 0 },
      floor4to7: { min: Infinity, max: -Infinity, avg: 0, unitCount: 0 },
      floor8to16: { min: Infinity, max: -Infinity, avg: 0, unitCount: 0 },
      floorAbove16: { min: Infinity, max: -Infinity, avg: 0, unitCount: 0 },
    };

    floors.forEach(floor => {
      const floorNumber = parseInt(floor.floorNo.replace("FLOOR ", ""), 10);
      const priceInLacs = floor.totalCost / 100000;

      if (floor.availableCount > 0) {
        if (floorNumber <= 3) priceRanges.floor1to3 = updatePriceRange(priceRanges.floor1to3, priceInLacs, floor.availableCount);
        else if (floorNumber <= 7) priceRanges.floor4to7 = updatePriceRange(priceRanges.floor4to7, priceInLacs, floor.availableCount);
        else if (floorNumber <= 16) priceRanges.floor8to16 = updatePriceRange(priceRanges.floor8to16, priceInLacs, floor.availableCount);
        else priceRanges.floorAbove16 = updatePriceRange(priceRanges.floorAbove16, priceInLacs, floor.availableCount);
      }
    });

    setPriceRanges(priceRanges);
  };

  const updatePriceRange = (range, price, unitCount) => {
    return {
      min: Math.min(range.min, price),
      max: Math.max(range.max, price),
      avg: range.avg + price,
      unitCount: range.unitCount + unitCount,
    };
  };

  const handleFloorClick = async (floorData) => {
    setLoading(true);
    console.log("Selected Floor Data:", floorData);
    try {
      const serverResp = await getTokenServerTime();
      const serverTime = serverResp?.data?.currentTime;
      const eventId = floorData.units[0]?.launchId?.eventId?.eventId || {};
      const launchId = floorData.units[0]?.launchId?.launchId || {};
      console.log("eventId", eventId);
      console.log("launchId", launchId);
      if (!eventId || !launchId) {
        setDialogMessage("No units available on this floor.");
        setOpenDialog(true);
        return;
      }

      const resp = await axios.post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}customerOnlineBooking/getEventOnlineBookingConfigDetails`,
        { eventId, launchId }
      );

      const { isOnlineBookingAccept, endDate } = resp?.data?.data;
      console.log("Booking Config:", {floorData :floorData.floorNo, paymentId ,tokenNo,wingId,wingName});
      if (isOnlineBookingAccept && serverTime <= endDate) {
        if (wingName === "A1") {
          navigate("/Home/TowerA1UnitSelection", { state: { floorData, paymentId, tokenNo, wingId, wingName, eventId, launchId } });
        }else if (wingName === "B1") {
          navigate("/Home/TowerB1UnitSelection", { state: { floorData, paymentId, tokenNo, wingId, wingName, eventId, launchId } });
        }else if (wingName === "A2") {
          navigate("/Home/TowerA2UnitSelection", { state: { floorData, paymentId, tokenNo, wingId, wingName, eventId, launchId } });
        }else if (wingName === "B2") {
          navigate("/Home/TowerB2UnitSelection", { state: { floorData, paymentId, tokenNo, wingId, wingName, eventId, launchId } });
        }else{
          navigate("/Home/Tokens")
        }
        // navigate("/Home/UnitSelection", { state: { floorNo: floorData?.floorNo, paymentId, tokenNo, wingId, wingName } });
      } else {
        setDialogMessage("Online booking ended or not available.");
        setOpenDialog(true);
      }
    } catch (error) {
      setDialogMessage("Error checking booking availability.");
      setOpenDialog(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    {loading ? (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "200px" // adjust if needed
    }}
  >
    <CircularProgress size={22} sx={{ color: "red" }} />
  </Box>
) : (
        <div className={cssClasses.wrapperTargetPage}>
          <Box
            onClick={() => navigate("/Home/Tokens")}
            sx={{
              display: "inline-block",
              fontSize: { xs: 12, sm: 14 },
              fontWeight: 500,
              textTransform: "uppercase",
              background: "linear-gradient(90deg, #0072ff 0%, #00b4e6ff 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              cursor: "pointer",
              position: "relative",
              letterSpacing: 0.5,
              "&::after": {
                content: '""',
                position: "absolute",
                left: 0,
                bottom: -3,
                width: "100%",
                height: 2,
                background: "linear-gradient(90deg, #0072ff, #00b4e6ff)",
                transform: "scaleX(0)",
                transformOrigin: "right",
                transition: "transform 0.3s ease",
              },
              "&:hover::after": {
                transform: "scaleX(1)",
                transformOrigin: "left",
              },
            }}
          >
            ← Go Back To Token
          </Box>
          <div className={cssClasses.mainContent} style={{backgroundColor:'white'}}>
            <div className={cssClasses.headerMainContent}>
              <div className={cssClasses.wrapperHeader}>
                <div
                  className={cssClasses.wrapperTitleUserName}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    gap: "12px",              // space between title + legend
                    flexWrap: "wrap"          // responsive on small screens
                  }}
                >
                  <div
                    className={cssClasses.headerTitle}
                    style={{
                      fontWeight: "bold",
                      fontSize: isSmallScreen ? "20px" : "",
                      marginRight: "10px",
                      paddingTop: "6px",

                    }}
                  >
                    Pick Your Floor
                  </div>

                  {/* Legend Container */}
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {/* Available Legend */}
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <div
                        style={{
                          width: "14px",
                          height: "14px",
                          backgroundColor: "#4CAF50", // green
                          borderRadius: "3px"
                        }}
                      ></div>
                      <span style={{ fontSize: "14px", color: "#333" }}>Available</span>
                    </div>

                    {/* Sold Legend */}
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <div
                        style={{
                          width: "14px",
                          height: "14px",
                          backgroundColor: "#E53935", // red
                          borderRadius: "3px"
                        }}
                      ></div>
                      <span style={{ fontSize: "14px", color: "#333" }}>Sold</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div
              style={{
                alignItems: "center",
                backgroundColor: "white",
                paddingTop: "15px",
                paddingBottom: "15px",
                height: "auto", // Allow height to adjust based on content
                maxHeight: "77vh", // Set max height to make it scrollable
                overflowY: "auto", // Enable scrolling when content overflows
              }}
            >




              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                
                <div className={styles.floorMapContainer} style={{ alignItems: "center", flexDirection: "column" }}>
                  {/* Rendering Floors */}
                  {floorData.map((floor, index) => {
                    const isMissing = floor.availableCount === 0;
                    return (
                      <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8, margin: "3px 0", width: '90%' }}>
                        <div style={{ paddingRight: "2px", fontSize: "13px", color: "#444", minWidth: 50, textAlign: "right" }}>FLOOR</div>
                        <div
                          className={`${styles.floor} ${isMissing ? styles.nonClickable : ""}`}
                          onClick={() => !isMissing && handleFloorClick(floor)}
                          style={{
                            backgroundColor: isMissing ? "#f5f5f5" : "#ffffff",
                            cursor: isMissing ? "default" : "pointer",
                            width: "80%",
                            maxWidth: 360,
                          }}
                        >

                          {/* Showing Available & Sold Units */}
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: 'center', marginTop: "0px", gap: 25 }}>
                            <div className={styles.floorLabel}>
                              <span style={{ fontSize: '14px' }} >{String(floor.floorNo.split(' ')[1]).padStart(2, '0')}</span>
                            </div>
                            <div style={{ backgroundColor: "#509401", padding: "6px 8px", borderRadius: "6px", color: "white", fontSize: "12px", minWidth: 40, textAlign: "center" }}>
                              {floor.availableCount}
                            </div>
                            <div style={{ backgroundColor: "#bf130d", padding: "6px 8px", borderRadius: "6px", color: "white", fontSize: "12px", minWidth: 40, textAlign: "center" }}>
                              {floor.soldCount}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>


              <div className={styles.floorMapContainerNew} style={{ alignItems: "center", display: 'flex', flexDirection: 'row', gap: 0, }}>
                {/* //add image here */}
                <img
                  src={'https://pufucoawlndmgmkuflpx.supabase.co/storage/v1/object/public/floorplans/M15(Lavinto)/Screenshot%202025-11-20%20154753.png'}
                  alt="Legend"
                  className={styles.floorMapContainerNew}
                  style={{ maxWidth: '320px', width: '100%', height: 'auto', marginTop: '4px' }}
                />


              </div>



            </div>

          </div>

        </div>
      )}

      {/* Dialog for messages */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <DialogContent sx={{ padding: "16px 24px", fontSize: "1.6rem", color: "#333" }}>
          <Box sx={{ backgroundColor: "#e3f2fd", padding: "10px", borderRadius: "10px", width: "100%", textAlign: "center", marginBottom: "16px" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1976d2" }}>
              Booking Unavailable !!
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ color: "#555", marginBottom: "16px" }}>
            {dialogMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end", backgroundColor: "#f7f7f7" }}>
          <Button onClick={() => setOpenDialog(false)} sx={{ fontWeight: 600, backgroundColor: "#1976d2", color: "#fff" }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FloorMappingNew;
